import { render, staticRenderFns } from "./detalleUnificacion.vue?vue&type=template&id=f2b6af78&scoped=true&%23row-details=row"
import script from "./detalleUnificacion.vue?vue&type=script&lang=js"
export * from "./detalleUnificacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b6af78",
  null
  
)

export default component.exports